<three-dot-menu>
    @for(item of navigationMenuItems(); track $index) { @if (item.isDivider) {
    <list-item [itemType]="'divider'"></list-item>
    } @else{
    <list-item
        [itemType]="item.external ? 'external-link' : 'list-default'"
        (onClick)="handleMenuItemClick(item)"
        [paddingLeft]="item.iconClass ? 0 : 50"
        [routeLink]="item.route"
        [itemText]="item.displayText"
    >
        <span class="flex" contentForListItem>
            @if (item.iconClass) {
            <span [class]="item.iconClass"></span>
            }
            {{ item.displayText }}
        </span>
    </list-item>
    } }
</three-dot-menu>
